"use strict";

export class IndividualPage {
  constructor() {}
}
